import type { RootState } from "@lib/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  details: {
    fullName: "",
    email: "",
    mobile: "",
    nationality: "",
    password: "",
    document: "",
    DocumentType: "",
    confirmPassword: "",
    broker: false,
    dldNumber: "",
    terms: false,
    dateOfBirth: "",
  },
};

export const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    setRegistrationDetails: (state, action: PayloadAction<any>) => {
      state.details = action.payload;
    },
    removeRegistrationDetails: (state) => {
      state.details = {
        fullName: "",
        email: "",
        mobile: "",
        nationality: "",
        password: "",
        document: "",
        DocumentType: "",
        confirmPassword: "",
        broker: false,
        dldNumber: "",
        terms: false,
        dateOfBirth: "",
      };
    },
  },
});

export const { setRegistrationDetails, removeRegistrationDetails } =
  registerSlice.actions;

export const getRegistrationDetails = (state: RootState) =>
  state.register.details;

export default registerSlice.reducer;
